<template lang="pug">
.popup(:class="additionalClass", @click.self="closePopup")
  .popup__wrap(@click.self="closePopup")
    .popup__content
      FrameDecor(:isTransparent="false", :hasBorder="false", :fillsContainer="true")
        button.popup__close(@click="closePopup")
          .icon.icon-close
        slot
    footer.popup__footer
      slot(name="footer_controls")
      .popup__control(v-if="isShowCloseButton" @click="closePopup") {{ $t('common.close_popup') }}
</template>

<script>
import FrameDecor from "@static_promo_pages/common/components/frame/vue/Frame.vue";

export default {
  name: "Popup",

  components: {
    FrameDecor,
  },

  props: {
    additionalClass: {
      type: String,
      default: () => "",
    },
    isShowCloseButton: {
      type: Boolean,
      default: true,
    },
  },

  mounted() {
    document.body.classList.add("popup-shown");
    document.addEventListener("keydown", this.closePopupByEsc);
  },

  beforeDestroy() {
    document.body.classList.remove("popup-shown");
    document.removeEventListener("keydown", this.closePopupByEsc);
  },

  methods: {
    closePopupByEsc(event) {
      if (event.keyCode == 27) {
        this.closePopup();
      }
    },

    closePopup() {
      this.$emit("closePopup");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../style/popup.scss";
</style>
